import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import EmailSubscribe from 'Components/EmailSubscribe/EmailSubscribe';
import { unsubscribe } from 'Redux/ducks/email-subscribe';

function EmailNewsletter({ emailNewsletter }) {
  const dispatch = useDispatch();
  const messages = defineMessages({
    join: {
      id: 'account.myaccount.join',
      defaultMessage: 'Join Newsletter',
    },
    preferenceCenter: {
      id: 'account-newsletter.preferenceCenter',
      defaultMessage: 'Preference Center',
    },
  });
  const intl = useIntl();
  const { formatMessage } = intl;
  const doUnsubscribe = () => {
    dispatch(unsubscribe());
  };

  return (
    <div className="account-table-row">
      <div className="account-table-row-title">
        <FormattedMessage id="account.setting.title.newsletter" defaultMessage="Email Newsletter" />
      </div>
      <div className="account-table-row-content">
        <div className="account-table-details-container">
          {emailNewsletter &&
            <span className="highlighted-text">
              <FormattedMessage id="account.setting.newsletter.subscribed" defaultMessage="Subscribed" />
            </span>
          }
          {!emailNewsletter &&
            <FormattedMessage id="account.setting.newsletter.not-subscribed" defaultMessage="Not Subscribed" />
          }

          <div className="account-table-details-smallprint">
            {emailNewsletter &&
              <React.Fragment>
                <FormattedMessage
                  id="account.setting.newsletter.smallprint.subscribed"
                  defaultMessage="Currently subscribed to our newsletter."
                />
                <button className="btn btn-link mb-1" onClick={doUnsubscribe}>
                  <FormattedMessage id="account.setting.newsletter.unsub" defaultMessage="Click here to unsubscribe from all marketing emails" />
                </button>
              </React.Fragment>
            }
            {!emailNewsletter &&
              <React.Fragment>
                <FormattedMessage
                  id="account.setting.newsletter.smallprint.unsubscribed"
                  defaultMessage="Join the Fanatical newsletter to be notified about promotions via Email. You can unsubscribe at any time. By subscribing you agree to our {privacyPolicyLink}."
                  values={{ privacyPolicyLink: <a href={'https://www.fandom.com/privacy-policy'} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage id="account.myaccount.privacypolicy" defaultMessage="Privacy Policy" />
                  </a>,
                  }}
                />
              </React.Fragment>
            }
          </div>
        </div>
        <div className="account-table-action-container">
          {!emailNewsletter &&
            <EmailSubscribe
              singleOptIn
              buttonText={formatMessage(messages.join)}
              context="Account"
            />
          }
          {emailNewsletter &&
            <Link to="/account/preferencecenter" className="account-table-action-button">
              <FormattedMessage
                id="account.setting.newsletter.button.preference-center"
                defaultMessage="Content Preferences"
              />
            </Link>
          }
        </div>
      </div>
    </div>
  );
}

EmailNewsletter.propTypes = {
  emailNewsletter: PropTypes.bool,
};

EmailNewsletter.defaultProps = {
  emailNewsletter: true,
  intl: {},
};

export default EmailNewsletter;
